import { Action, Reducer } from "redux";

import { KnownAction } from "./AppActions";
import type { AppViewState } from "./AppState.types";

export const initialState: AppViewState = { isEmbedded: false };

export const reducer: Reducer<AppViewState> = (
    _,
    action: Action,
): AppViewState => {
    return { isEmbedded: (action as KnownAction).isEmbedded };
};
